import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'nucleus-core/layout/flexbox';

/**
* Default renderer for a CONTAINER type layout item.
*/
export default class Container extends React.Component {
  static displayName = 'Container';
  static propTypes = {
    children: PropTypes.node
  };
  render() {
    const { children } = this.props;
    return (
      <Grid breakPoint="small">
        {children}
      </Grid>
    );
  }
}
